import Fieldset from 'components/_UI/Fieldset'
import React from 'react'

import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'
import { Row } from 'styled/alignment/Row'
import colors from 'theme/colors'
import Select from 'react-select';
import breakpoints from 'theme/breakpoints'


export default function FilterExpenses() {
  return (
    <Container>
      <Content>
        <Fieldset layout='squired' placeholder='Procure' marginTop={'0'}/>
      </Content>
        <ContentSelects>
          <Select />
        </ContentSelects>
         <ContentSelects>
          <Select />
        </ContentSelects>
        <ContentSelects>
          <Select />
        </ContentSelects>
    </Container>
  )
}


const Container = styled(Column)`
  width: 100%;
  background: ${colors.neutralLight};
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  padding: 15px;
   @media screen and (min-width: ${breakpoints.lg}) {
    flex-direction: row;
    gap: 4px;
  }
`;

const Content = styled(Column)`
  display: flex;
  width: 100%;
  
  justify-content: space-around;
  & > div  {
    padding-bottom: 0px;
    & > input {
      margin-top: 0px;
    }
  }

  @media screen and (min-width: ${breakpoints.lg}) {
    flex-direction: row;
    width: 45%;
    
  }
`

const ContentSelects = styled(Column)`
  width: 100%;
  @media screen and (min-width: ${breakpoints.lg}) {
    width: 18.33%;
  }
`